import { Navigate } from 'react-router-dom'
import { LOCALIZATION_TRANSLATIONS_PATH, useGenerateCompanyPath } from '@/libs'

export const L10nRedirect = () => {
  const { generatePath } = useGenerateCompanyPath()
  return <Navigate replace to={generatePath(LOCALIZATION_TRANSLATIONS_PATH)} />
}
